import { loadScript } from "@videojs/utils/dom";
//#region src/iframe-api.ts
const API_URL = "https://open.spotify.com/embed/iframe-api/v1";
let apiPromise = null;
/** Load the iframe API once, reusing it if another host already pulled it in. */
function loadSpotifyIframeApi() {
	const globals = globalThis;
	const existing = globals.SpotifyIframeApi;
	if (existing) return Promise.resolve(existing);
	apiPromise ??= new Promise((resolve, reject) => {
		const hostReady = globals.onSpotifyIframeApiReady;
		globals.onSpotifyIframeApiReady = (api) => {
			resolve(api);
			hostReady?.(api);
		};
		loadScript(API_URL).catch(reject);
	}).catch((error) => {
		apiPromise = null;
		throw error;
	});
	return apiPromise;
}
//#endregion
export { loadSpotifyIframeApi };
